import { Controller } from "@hotwired/stimulus"

// "stalled", "canplay", "ended" and "click" are all native <video>/DOM events, so every binding
// here is a plain data-action rather than a jQuery listener.
export default class extends Controller {
  static get targets() {
    return ["video", "playIcon", "loadingIcon", "manualPoster", "progressBar", "progressHolder"];
  }

  static get classes() {
    return ["hidden", "invisible"];
  }

  connect() {
    this.playProgressInterval = null;

    if (document.querySelector("html.mobile")) {
      this.mobileTimeout = setTimeout(() => this.togglePlayUi(false), 5000);
    }
  }

  disconnect() {
    this.stopTrackingPlayProgress();
    if (this.mobileTimeout) { clearTimeout(this.mobileTimeout); }
  }

  stalled() {
    if (this.hasLoadingIconTarget) { this.loadingIconTarget.classList.remove(this.hiddenClass); }
  }

  canplay() {
    if (this.hasLoadingIconTarget) { this.loadingIconTarget.classList.add(this.hiddenClass); }
    if (this.hasPlayIconTarget) { this.playIconTarget.classList.remove(this.hiddenClass); }
  }

  ended() {
    this.togglePlayUi(false);

    if (this.hasManualPosterTarget) { this.manualPosterTarget.classList.remove(this.invisibleClass); }
    this.videoTarget.classList.add(this.invisibleClass);
    this.videoTarget.currentTime = 0;
    this.stopTrackingPlayProgress();
    this.updatePlayProgress();
  }

  click() {
    if (this.videoTarget.paused) {
      this.videoTarget.play();
      this.togglePlayUi(true);
      this.trackPlayProgress();
    } else {
      this.videoTarget.pause();
      this.togglePlayUi(false);
      this.stopTrackingPlayProgress();
    }
  }

  togglePlayUi(isPlaying) {
    if (isPlaying) {
      if (this.hasPlayIconTarget) { this.playIconTarget.classList.add(this.hiddenClass); }
      this.videoTarget.classList.remove(this.invisibleClass);
      if (this.hasManualPosterTarget) { this.manualPosterTarget.classList.add(this.invisibleClass); }
    } else {
      if (this.hasPlayIconTarget) { this.playIconTarget.classList.remove(this.hiddenClass); }
      if (this.hasLoadingIconTarget) { this.loadingIconTarget.classList.add(this.hiddenClass); }
    }
  }

  trackPlayProgress() {
    this.stopTrackingPlayProgress();
    this.playProgressInterval = setInterval(() => this.updatePlayProgress(), 33);
  }

  stopTrackingPlayProgress() {
    if (this.playProgressInterval) { clearInterval(this.playProgressInterval); }
    this.playProgressInterval = null;
  }

  updatePlayProgress() {
    if (!this.hasProgressBarTarget) { return; }

    const progress = (this.videoTarget.currentTime / this.videoTarget.duration) * this.progressHolderTarget.offsetWidth;
    this.progressBarTarget.style.width = `${progress}px`;
  }
}
